import { Pipe, PipeTransform } from '@angular/core';
import _ from "lodash";

@Pipe({name: 'extractData'})
export class ExtractDataPipe implements PipeTransform {
    transform(
        data: any,
        path: string
    ): string {
        return _.get(data, path, '');
    }
}
